module.exports = __webpack_public_path__ + "static/pakmaya-ppd-web-964f40554e05d2fa9ea1edb8a17b9859.jpg";